import { Component } from '@angular/core';
import { EntitySelectorComponent } from '@app/selection/entity-selector.component';
import { LegalEntity } from '@app/_models/_DTOs/legalEntity';
import { LegalEntityService } from '@app/_services/legalEntity.service';

@Component({
  selector: "app-legal-entity-selector",
  templateUrl: "./legal-entity-selector.component.html",
  styleUrls: ["./legal-entity-selector.component.css"],
})
export class LegalEntitySelectorComponent extends EntitySelectorComponent<LegalEntity> {
  constructor(private legalEntityService: LegalEntityService) {
    super(legalEntityService);
  }
}